import { ChangeDetectionStrategy, Component, Inject } from '@angular/core';
import { TypedDialog } from '@platform/dialog/dialog-v2.service';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { getFileExtension, getFileNameWithoutExtension } from '@platform/shared/utilities/file-utility';
import { requireValidFilename } from '@platform/shared/utilities/filename-validator';

export interface FileRenameDialogData {
  fileName: string;
  isFolder: boolean;
  invalidFileAndFolderNameCharacters: string[];
}

export interface FileRenameDialogReturn {
  isFolder: boolean;
  originalFileName: string;
  newFileName: string;
}

interface FileRenameDialogForm {
  fileName: FormControl<string | null>;
}

@Component({
  selector: 'app-file-rename-dialog',
  templateUrl: './file-rename-dialog.component.html',
  styleUrls: ['./file-rename-dialog.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FileRenameDialogComponent implements TypedDialog<FileRenameDialogComponent, FileRenameDialogData, FileRenameDialogReturn> {
  public readonly form: FormGroup<FileRenameDialogForm>;
  public readonly fileExtension: string;

  constructor(
    public dialogRef: MatDialogRef<FileRenameDialogComponent, FileRenameDialogReturn>,
    @Inject(MAT_DIALOG_DATA) public data: FileRenameDialogData,
    formBuilder: FormBuilder,
  ) {
    this.fileExtension = data.isFolder ? '' : '.' + getFileExtension(data.fileName);

    this.form = formBuilder.group({
      fileName: [
        data.isFolder ? data.fileName : getFileNameWithoutExtension(data.fileName),
        [Validators.required, requireValidFilename(data.invalidFileAndFolderNameCharacters)],
      ],
    });
  }

  public isNameUnchanged(): boolean {
    const newName = `${this.form.value.fileName}${this.fileExtension}`;

    // SharePoint does not allow only changing the case of a character
    return newName.toLocaleLowerCase() === this.data.fileName.toLocaleLowerCase();
  }

  public submit() {
    this.dialogRef.close({
      isFolder: this.data.isFolder,
      originalFileName: this.data.fileName,
      newFileName: `${this.form.value.fileName}${this.fileExtension}`,
    });
  }

  public close() {
    this.dialogRef.close();
  }
}
